type OrderedMessage = {
  message_id?: string | number | null;
  created_at?: { seconds?: string | number; nanos?: number };
};

export function compareMessages(a: OrderedMessage, b: OrderedMessage): number {
  const seconds = Number(a.created_at?.seconds || 0) - Number(b.created_at?.seconds || 0);
  if (seconds) return seconds;
  const aId = String(a.message_id ?? "");
  const bId = String(b.message_id ?? "");
  if (/^\d+$/.test(aId) && /^\d+$/.test(bId)) {
    const left = aId.replace(/^0+/, "") || "0";
    const right = bId.replace(/^0+/, "") || "0";
    return left.length - right.length || (left < right ? -1 : left > right ? 1 : 0);
  }
  return (a.created_at?.nanos || 0) - (b.created_at?.nanos || 0);
}
